import styled, { css } from 'styled-components';

import { isFrenchLocale } from '@/helpers/languages';

import { device } from '@/styles/helpers';
import { hexToRGB } from '@/styles/helpers';

export interface ScWheelButtonProps {
  isSpinning: boolean;
  isLocked: boolean;
  lng: string;
  isAuth: boolean;
}

export const ScWheelButton = styled.button<ScWheelButtonProps>`
  position: absolute;
  display: block;
  width: 112px;
  height: 112px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  z-index: 6;
  background: ${({ theme }) => theme.blackColor};

  @media (${device.mobile}) {
    width: 102px;
    height: 102px;

    ${({ isAuth }) =>
      isAuth &&
      css`
        width: 80px;
        height: 80px;
      `}
  }

  &::after {
    content: '';
    position: absolute;
    display: block;
    padding: 4px;
    background: ${({ theme }) => theme.goldGradient};
    border-radius: 50%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
  }

  .message {
    position: absolute;
    z-index: 1;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: ${({ lng, isAuth }) => {
      if (!isAuth) {
        return lng === 'de' ? '14px' : '16px';
      }

      return isFrenchLocale(lng) ? '20px' : '22px';
    }};
    font-weight: 700;
    line-height: ${({ lng }) => (isFrenchLocale(lng) ? '24px' : '28px')};
    letter-spacing: 0.02em;
    text-align: center;
    white-space: pre-line;
    text-transform: uppercase;
    color: ${({ theme, isSpinning }) =>
      isSpinning ? hexToRGB(theme.whiteColor, 0.2) : theme.cedarWoodColor};

    @media (${device.mobile}) {
      font-size: ${({ lng, isAuth }) =>
        !isAuth && lng === 'de'
          ? '10px'
          : isFrenchLocale(lng)
            ? '12px'
            : '14px'};
      line-height: ${({ lng, isAuth }) =>
        isFrenchLocale(lng) || (!isAuth && lng === 'de') ? '14px' : '18px'};
    }
  }

  ${({ isLocked }) =>
    isLocked &&
    css`
      width: 330px;
      height: 110px;
      border-radius: 12px;
      cursor: initial;

      &::after {
        border-radius: 16px;
      }

      @media (${device.mobile}) {
        font-size: 16px;
        width: 212px;
        height: 67px;
      }

      .message {
        font-size: 24px;
        width: 100%;
        color: ${({ theme }) => theme.cedarWoodColor};
        padding: 16px 12px;

        @media (${device.mobile}) {
          font-size: 16px;
          padding: 10px 8px;
        }
      }
    `}

  ${({ isSpinning, isLocked }) =>
    (!isSpinning || isLocked) &&
    css`
      background: linear-gradient(
        180deg,
        #bd5d0d 0%,
        #ffad01 25.84%,
        #ffd500 52.78%,
        #ffad01 80.27%,
        #bd5d0d 105.56%
      );
    `}
`;
